import { useNavigate, useParams } from 'react-router-dom'

import { ReconciliationFromBankAccountSidePanelDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ReconciliationSidePanel } from 'modules/finance/components/ReconciliationSidepanel'

export const ReconciliationFromBankAccountSidePanel = () => {
  const { id: bankAccountId } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { data } = useQuery(ReconciliationFromBankAccountSidePanelDocument, {
    variables: { bankAccountId: String(bankAccountId) },
  })
  const { reconciliationsSeeJournalEntriesPage } = data?.banking?._policies || {
    reconciliationsSeeJournalEntriesPage: { can: false },
  }
  const currency = data?.banking.bankAccount?.currency ?? ''

  if (!bankAccountId || !data) return null

  const onCloseSidePanel = () => {
    navigate(navigation.finance.banking.accounts.accountId.fullPath({ id: bankAccountId }))
  }

  return (
    <ReconciliationSidePanel
      sourceType="bankAccount"
      sourceId={String(bankAccountId)}
      canReconcile={reconciliationsSeeJournalEntriesPage.can}
      currency={currency}
      onCloseSidePanel={onCloseSidePanel}
      title={i18n.t('finance.reconciliations.bank_type_journal_lines.title')}
      subtitle={i18n.t('finance.reconciliations.bank_type_journal_lines.description')}
      reconcilableJournalLineTitle={i18n.t('finance.reconciliations.match_with_journal_lines')}
      summaryTitle={i18n.t('finance.reconciliations.summary_empty_state_from_bank_account.title')}
      summarySubtitle={i18n.t(
        'finance.reconciliations.summary_empty_state_from_bank_account.description'
      )}
    />
  )
}
